import * as api from "../apis/placementsApi";
import {
  useQuery,
  useQueryClient,
  queryOptions,
  useSuspenseQuery,
} from "@tanstack/react-query";


// Query options

export const getPlacementsQueryOptions = () =>
  queryOptions({
    queryKey: ["placements"],
    queryFn: api.getPlacements,
    refetchOnWindowFocus: "always",
    
  });

export const getPlacementsByPlatformQueryOptions = (platformId, queryClient) =>
  queryOptions({
    queryKey: ["platform.placements", platformId],
    queryFn: () => api.getPlacementsByPlatform(platformId),
    refetchOnWindowFocus: "always",
    
    initialData: () =>
      queryClient
        .getQueryData(["placements"])
        ?.filter((placement) => placement.platform.id === platformId),
    initialDataUpdatedAt: () =>
      queryClient.getQueryState(["placements"])?.dataUpdatedAt,
  });

export const getPlacementQueryOptions = (id, queryClient) => {
  let queryKey;

  return queryOptions({
    queryKey: ["placement", id],
    queryFn: () => api.getPlacement(id),
    refetchOnWindowFocus: "always",
    
    initialData: () => {
      // if "placements" query exist, we use it to init data
      if (queryClient.getQueryState(["placements"])) {
        queryKey = ["placements"];
        return queryClient
          .getQueryData(["placements"])
          ?.find((placement) => placement.id === id);
      }

      // otherwise, we try to find the placement in one of the "platform.placements" queries
      let found;

      queryClient
        .getQueriesData({ queryKey: ["platform.placements"] })
        .forEach((query) => {
          const data = query[1];
          data.forEach((placement) => {
            if (placement.id === id) {
              found = placement;
              queryKey = query[0];
            }
          });
        });

      return found;
    },
    initialDataUpdatedAt: () =>
      queryClient.getQueryState(queryKey)?.dataUpdatedAt,
  });
};

// useQuery

export const useGetPlacementsByPlatform = (platformId) => {
  const queryClient = useQueryClient();
  return useQuery(getPlacementsByPlatformQueryOptions(platformId, queryClient));
};

export const useGetPlacement = (id) => {
  const queryClient = useQueryClient();
  return useQuery(getPlacementQueryOptions(id, queryClient));
};

// useSuspenseQuery

export const useSuspenseGetPlacements = () => {
  return useSuspenseQuery(getPlacementsQueryOptions());
};

export const useSuspenseGetPlacement = (id) => {
  const queryClient = useQueryClient();
  return useSuspenseQuery(getPlacementQueryOptions(id, queryClient));
};

export const useSuspenseGetPlacementsByPlatform = (platformId) => {
  const queryClient = useQueryClient();
  return useSuspenseQuery(getPlacementsByPlatformQueryOptions(platformId, queryClient));
};

